import React from "react";
import FileTextIcon from "../../images/file-text.svg";

interface PrivacyPolicyProps {
  acceptedTerms: boolean;
  setAcceptedTerms: (value: boolean) => void;
}

export function PrivacyPolicy({
  acceptedTerms,
  setAcceptedTerms,
}: PrivacyPolicyProps) {
  return (
    <div className="privacyPolicyContainer">
      <div>
        <span>Política de privacidade</span>

        <label>
          <input
            type="checkbox"
            checked={acceptedTerms}
            onChange={() => setAcceptedTerms(!acceptedTerms)}
          />
          Li e concordo com a política de privacidade.
        </label>
      </div>
      <a
        href="https://www.koin.com.br/politica-de-privacidade/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={FileTextIcon} alt="File Text Icon" />
        Ler políticas de privacidade
      </a>
    </div>
  );
}
